/**
 * @generated SignedSource<<32d14a78f17cdb89c72e97de94fef8a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type aiConsultDetailQuery$variables = {
  linkparameter: string;
  recipientid: string;
};
export type aiConsultDetailQuery$data = {
  readonly insurance_request_log_connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly aiconsultdetailid: number | null | undefined;
        readonly caredetailid: number | null | undefined;
        readonly created_at: any | null | undefined;
        readonly id: string;
        readonly insurance: {
          readonly id: string;
          readonly name: string;
          readonly user: {
            readonly email: string | null | undefined;
            readonly imageurl: string | null | undefined;
            readonly name: string;
          } | null | undefined;
        } | null | undefined;
        readonly insuranceid: string;
        readonly recipient: {
          readonly email: string | null | undefined;
          readonly id: string;
          readonly imageurl: string | null | undefined;
          readonly last_seen: any;
          readonly name: string;
        } | null | undefined;
        readonly recipientid: string | null | undefined;
        readonly request_ai_consult_details: {
          readonly askingotherthingscounter: number;
          readonly chatHistory: string;
          readonly created_at: any;
          readonly customerfeedback: string | null | undefined;
          readonly customerrating: any | null | undefined;
          readonly id: string;
          readonly linkparameter: string;
          readonly messages: any | null | undefined;
          readonly questionsummary: string | null | undefined;
          readonly reportmarkdown: string | null | undefined;
          readonly reportpublishdate: any | null | undefined;
          readonly startchatdate: any | null | undefined;
          readonly status: number | null | undefined;
        } | null | undefined;
        readonly requeststatus: number;
        readonly requesttype: number;
      };
    }>;
  };
};
export type aiConsultDetailQuery = {
  response: aiConsultDetailQuery$data;
  variables: aiConsultDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "linkparameter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recipientid"
  }
],
v1 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "_eq",
            "variableName": "recipientid"
          }
        ],
        "kind": "ObjectValue",
        "name": "recipientid"
      },
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "linkparameter"
              }
            ],
            "kind": "ObjectValue",
            "name": "linkparameter"
          }
        ],
        "kind": "ObjectValue",
        "name": "request_ai_consult_details"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "request_ai_consult_detail",
  "kind": "LinkedField",
  "name": "request_ai_consult_details",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkparameter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startchatdate",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chatHistory",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "askingotherthingscounter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerfeedback",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerrating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "questionsummary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reportmarkdown",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reportpublishdate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageurl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "users",
  "kind": "LinkedField",
  "name": "recipient",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last_seen",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requeststatus",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requesttype",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientid",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "insuranceid",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "caredetailid",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiconsultdetailid",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiConsultDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "insurance_request_logConnection",
        "kind": "LinkedField",
        "name": "insurance_request_log_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "insurance_request_logEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "insurance_request_log",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "insurance_agent",
                    "kind": "LinkedField",
                    "name": "insurance",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "users",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "aiConsultDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "insurance_request_logConnection",
        "kind": "LinkedField",
        "name": "insurance_request_log_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "insurance_request_logEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "insurance_request_log",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "insurance_agent",
                    "kind": "LinkedField",
                    "name": "insurance",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "users",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "df2abfcadc6fc663983df623ff89cff3",
    "id": null,
    "metadata": {},
    "name": "aiConsultDetailQuery",
    "operationKind": "query",
    "text": "query aiConsultDetailQuery(\n  $linkparameter: String!\n  $recipientid: String!\n) {\n  insurance_request_log_connection(where: {request_ai_consult_details: {linkparameter: {_eq: $linkparameter}}, recipientid: {_eq: $recipientid}}) {\n    edges {\n      node {\n        request_ai_consult_details {\n          id\n          linkparameter\n          startchatdate\n          created_at\n          chatHistory\n          askingotherthingscounter\n          customerfeedback\n          customerrating\n          questionsummary\n          reportmarkdown\n          reportpublishdate\n          status\n          messages\n        }\n        recipient {\n          id\n          email\n          imageurl\n          last_seen\n          name\n        }\n        requeststatus\n        requesttype\n        recipientid\n        insuranceid\n        id\n        created_at\n        caredetailid\n        aiconsultdetailid\n        insurance {\n          id\n          name\n          user {\n            name\n            email\n            imageurl\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d883924a954b344f1e7c7ac4ee1811a8";

export default node;
